import axios from "axios";
import { api } from "./api_route";

export const createSec9InterimOrdersAPI = async (sec9InterimOrdersData) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      sec9InterimOrdersData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/sec9InterimOrder/create`,
      sec9InterimOrdersData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getSec9InterimOrdersByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(`${api}/sec9InterimOrder/case/${caseID}`);
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateSec9InterimOrdersAPI = async (
  sec9InterimOrders_ID,
  sec9InterimOrdersData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      sec9InterimOrdersData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/sec9InterimOrder/update/${sec9InterimOrders_ID}`,
      sec9InterimOrdersData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteSec9InterimOrdersAPI = async (sec9InterimOrders_ID) => {
  try {
    const response = await axios.delete(
      `${api}/sec9InterimOrder/delete/${sec9InterimOrders_ID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};
